"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const SongwriterRegistrationHeader_1 = __importDefault(require("@Scenes/SongwriterRegistrationScene/SongwriterRegistrationHeader"));
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const create_songwriter_1 = require("@Entities/schemas/songwriter/create-songwriter");
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const songwriter_1 = require("@App/api/routes/songwriter/songwriter");
const react_router_dom_1 = require("react-router-dom");
const convert_empty_values_to_undefined_1 = __importDefault(require("@App/forms/v2/helpers/convert-empty-values-to-undefined"));
const SongwriterRegistrationForm_1 = __importDefault(require("@Scenes/SongwriterRegistrationScene/SongwriterRegistrationForm"));
const SongwriterRegistrationScene = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { userStore, preloaderStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        delayError: 750,
        resolver: (0, zod_1.zodResolver)(create_songwriter_1.createSongwriterFormSchema),
        defaultValues: {},
    });
    const onSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        data = (0, convert_empty_values_to_undefined_1.default)(data, true);
        preloaderStore.openTransparentPreloader(true);
        try {
            yield (0, songwriter_1.createSongwriter)(data).then((newSongwriter) => {
                userStore.setUserViewedWelcomePopup();
                navigate(navigation_1.default.songwriter.catalogBuilder(newSongwriter.data.id));
            });
        }
        catch (e) {
            popupStore.setAlertFromError(e);
        }
        finally {
            preloaderStore.openTransparentPreloader(false);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: "Songwriter registration" }),
        react_1.default.createElement("main", { className: "create-songwriter-scene" },
            react_1.default.createElement("div", { className: "global-container" },
                react_1.default.createElement("div", { className: "songwriter-registration-scene-wrapper" },
                    react_1.default.createElement(SongwriterRegistrationHeader_1.default, null),
                    react_1.default.createElement(SongwriterRegistrationForm_1.default, { methods: methods, onSubmit: (data) => onSubmit(data) }))))));
};
exports.default = SongwriterRegistrationScene;
